import styled from "styled-components";

const ProgressBarStyled = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 2rem 0;
  position: relative;
  @media only screen and (min-width: 768px) {
    padding: 5rem 0;
    margin-bottom: 5rem;
    &.hideDesktop {
      display: none;
    }
  }
`;

export default ProgressBarStyled;
